// 用户
import { request,pretty } from '@/utils/request' 
export const loginAdmin = (item)=>{
  return pretty(request.post(`/api/Admin/Login?userName=${item.username}&password=${item.password}`));

}
export const addAdmin = (item)=>{
  return pretty(request.post("/api/Admin/Add",{...item}));
}
export const changePwdAdmin = (item)=>{
  return pretty(request.post(`/api/Admin/ChangePwd?oldPwd=${item.orgpass}&newPwd=${item.pass}&confirmPwd=${item.checkPass}`));
}
export const deleteAdmin = (item)=>{
  return pretty(request.post(`/api/Admin/Delete?ids=${item}`));
}
export const detailAdmin = (item)=>{
  return pretty(request.get(`/api/Admin/Detail?id=${item}`));
}
export const editAdmin = (item)=>{
  return pretty(request.post("/api/Admin/Edit",{...item}));
}
export const listAdmin = (item)=>{
  return pretty(request.get(`/api/Admin/List?realName=${item?.name?(item?.name):''}&pageSize=${((item?.pageSize)||(item?.pageSize==0))?(item?.pageSize):10}&pageIndex=${(item?.pageIndex||item?.pageSize==0)?(item?.pageIndex):1}`));
}
export const resetPwdAdmin = (item,roles)=>{
  return pretty(request.post(`/api/Admin/ResetPwd?AdminId=${item.Id}&newPwd=${item.newPwd}`));
}
